import { render, staticRenderFns } from "./AppointmentDataModal.vue?vue&type=template&id=45712e1a&"
import script from "./AppointmentDataModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentDataModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDataModal.vue?vue&type=style&index=0&id=45712e1a&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45712e1a')) {
      api.createRecord('45712e1a', component.options)
    } else {
      api.reload('45712e1a', component.options)
    }
    module.hot.accept("./AppointmentDataModal.vue?vue&type=template&id=45712e1a&", function () {
      api.rerender('45712e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentPage/components/common/AppointmentDataModal.vue"
export default component.exports